var _path, _path2, _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffersActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80137 2.51276C8.44355 1.80457 9.55645 1.80457 10.1986 2.51276C10.8455 3.2261 11.7778 3.61228 12.7396 3.56527C13.6945 3.5186 14.4814 4.30553 14.4347 5.26038C14.3877 6.22219 14.7739 7.15451 15.4872 7.80137C16.1954 8.44355 16.1954 9.55645 15.4872 10.1986C14.7739 10.8455 14.3877 11.7778 14.4347 12.7396C14.4814 13.6945 13.6945 14.4814 12.7396 14.4347C11.7778 14.3877 10.8455 14.7739 10.1986 15.4872C9.55645 16.1954 8.44355 16.1954 7.80137 15.4872C7.15451 14.7739 6.22219 14.3877 5.26038 14.4347C4.30553 14.4814 3.5186 13.6945 3.56527 12.7396C3.61228 11.7778 3.2261 10.8455 2.51276 10.1986C1.80457 9.55645 1.80457 8.44355 2.51276 7.80137C3.2261 7.15451 3.61228 6.22219 3.56527 5.26038C3.5186 4.30553 4.30553 3.5186 5.26038 3.56527C6.22219 3.61228 7.15451 3.2261 7.80137 2.51276Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.0003L12 6.85742",
    stroke: "url(#paint1_linear)",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.28571,
    cy: 7.28571,
    r: 0.8,
    stroke: "url(#paint2_linear)",
    strokeWidth: 0.971429
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7144,
    cy: 11.5709,
    r: 0.8,
    stroke: "url(#paint3_linear)",
    strokeWidth: 0.971429
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -3,
    y1: -1.04308e-7,
    x2: 18,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#4991C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#5267A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#8E559D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 5,
    y1: 6.85742,
    x2: 10.9294,
    y2: 13.7751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#4991C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#5267A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#8E559D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 5.57143,
    y1: 6,
    x2: 8.57143,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#4991C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#5267A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#8E559D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 9.00014,
    y1: 10.2852,
    x2: 12.0001,
    y2: 13.2852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#4991C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#5267A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#8E559D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74994"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersActive);
export default __webpack_public_path__ + "static/media/offers--active.7da73db8155e8244367926e29d3f9150.svg";
export { ForwardRef as ReactComponent };